import React from 'react';
import cx from 'clsx';
import styles from './styles.module.css';
export const PopoverContent = ({
  result
}) => {
  let linkLabel = null;
  let url = null;
  if (result.data.url) {
    url = result.data.url;
    linkLabel = 'View Listing';
  }
  return /*#__PURE__*/React.createElement("a", {
    href: url || '#',
    className: cx("ay-property-listing-card", styles.PopoverContent)
  }, /*#__PURE__*/React.createElement("div", {
    className: "ay-property-listing-card__inner"
  }, result.data.imageUrl && /*#__PURE__*/React.createElement("div", {
    className: "ay-property-listing-card__image"
  }, /*#__PURE__*/React.createElement("img", {
    src: result.data.imageUrl,
    title: result.data.title
  })), /*#__PURE__*/React.createElement("div", {
    className: "ay-property-listing-card__details"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "ay-property-listing-card__title"
  }, result.locationName), /*#__PURE__*/React.createElement("div", {
    className: "ay-property-listing-card__meta-item"
  }, /*#__PURE__*/React.createElement("div", null, result.fields.displayAddress[0]), result.fields.displayAddress[1] && /*#__PURE__*/React.createElement("div", null, result.fields.displayAddress[1]), result.fields.displayAddress[2] && /*#__PURE__*/React.createElement("div", null, result.fields.displayAddress[2])))));
};
export default PopoverContent;